import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-copy_file",
  "use": "icon-copy_file-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-copy_file\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M9,9V6.6A.6.6,0,0,1,9.6,6h7.8a.6.6,0,0,1,.6.6v7.8a.6.6,0,0,1-.6.6H15v2.4a.6.6,0,0,1-.6.6H6.6a.6.6,0,0,1-.6-.6H6V9.6A.6.6,0,0,1,6.61,9Zm1.2,0h4.2a.6.6,0,0,1,.6.6v4.2h1.8V7.2H10.2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol